var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1446,
    height: 244,
    viewBox: "0 0 1446 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "banner",
    transform: "translate(36 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-footer",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2021-01-28",
    "data-name": "2021-01-28",
    transform: "translate(274 296)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-01-28")), /*#__PURE__*/React.createElement("text", {
    id: "_2020-01-21",
    "data-name": "2020-01-21",
    transform: "translate(-6 296)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020-01-21")), /*#__PURE__*/React.createElement("text", {
    id: "_2021-02-04",
    "data-name": "2021-02-04",
    transform: "translate(524 296)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-02-04")), /*#__PURE__*/React.createElement("text", {
    id: "_2021-02-11",
    "data-name": "2021-02-11",
    transform: "translate(814 296)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-02-11")), /*#__PURE__*/React.createElement("text", {
    id: "_2021-02-18",
    "data-name": "2021-02-18",
    transform: "translate(1094 296)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-02-18"))), /*#__PURE__*/React.createElement("g", {
    id: "divider-horizontal-group",
    transform: "translate(-9 193.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-1",
    width: 1418,
    height: 1,
    transform: "translate(1 86.004)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-2",
    width: 1418,
    height: 1,
    transform: "translate(1 65.004)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-3",
    width: 1418,
    height: 1,
    transform: "translate(1 43.004)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-4",
    width: 1418,
    height: 1,
    transform: "translate(1 22.004)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-5",
    width: 1418,
    height: 1,
    transform: "translate(1 0.004)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-6",
    width: 1418,
    height: 1,
    transform: "translate(1 -20.996)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-7",
    width: 1418,
    height: 1,
    transform: "translate(1 -41.996)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-8",
    width: 1418,
    height: 1,
    transform: "translate(1 -63.996)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-9",
    width: 1418,
    height: 1,
    transform: "translate(1 -84.996)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-10",
    width: 1418,
    height: 1,
    transform: "translate(1 -106.996)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-horizontal-10-2",
    "data-name": "divider-horizontal-10",
    width: 1418,
    height: 1,
    transform: "translate(0 -128.996)",
    opacity: 0.051
  })), /*#__PURE__*/React.createElement("g", {
    id: "divider-vertical-group",
    transform: "translate(0 65.557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-6",
    width: 1,
    height: 214,
    transform: "translate(1409 0.443)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-5",
    width: 1,
    height: 214,
    transform: "translate(1115 0.443)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-4",
    width: 1,
    height: 214,
    transform: "translate(834 0.443)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-3",
    width: 1,
    height: 214,
    transform: "translate(555 0.443)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-2",
    width: 1,
    height: 214,
    transform: "translate(275 0.443)",
    opacity: 0.051
  }), /*#__PURE__*/React.createElement("rect", {
    id: "divider-vertical-1",
    width: 1,
    height: 214,
    transform: "translate(-9 0.443)",
    opacity: 0.051
  })), /*#__PURE__*/React.createElement("g", {
    id: "pillar",
    transform: "translate(5 69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "day-1",
    d: "M448,822V746a10,10,0,1,1,20,0v76",
    transform: "translate(-448 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-2",
    d: "M494,822V758a10,10,0,0,1,20,0v64",
    transform: "translate(-454 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-3",
    d: "M540,822V778a10,10,0,1,1,20,0v44",
    transform: "translate(-460 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-4",
    d: "M586,822V803a10,10,0,1,1,20,0v19",
    transform: "translate(-466 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-5",
    d: "M633,822V798a10,10,0,0,1,20,0v24",
    transform: "translate(-473 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-6",
    d: "M679,822V758a10,10,0,0,1,20,0v64",
    transform: "translate(-479 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-7",
    d: "M725,822V708a10,10,0,1,1,20,0V822",
    transform: "translate(-484.982 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-8",
    d: "M771,822V680a10,10,0,1,1,20,0V822",
    transform: "translate(-490.982 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-9",
    d: "M817,822V688a10,10,0,0,1,20,0V822",
    transform: "translate(-496.983 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-10",
    d: "M863,822V713a10,10,0,1,1,20,0V822",
    transform: "translate(-502.984 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-11",
    d: "M909,822V748a10,10,0,1,1,20,0v74",
    transform: "translate(-508.984 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-12",
    d: "M956,822V778a10,10,0,0,1,20,0v44",
    transform: "translate(-515.963 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-13",
    d: "M1002,822V758a10,10,0,0,1,20,0v64",
    transform: "translate(-521.964 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-14",
    d: "M1048,822V716a10,10,0,0,1,20,0V822",
    transform: "translate(-527.964 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-15",
    d: "M1094,822V677a10,10,0,1,1,20,0V822",
    transform: "translate(-533.965 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-16",
    d: "M1140,822V660a10,10,0,0,1,20,0V822",
    transform: "translate(-539.966 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-17",
    d: "M1186,822V676a10,10,0,1,1,20,0V822",
    transform: "translate(-545.966 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-18",
    d: "M1232,822V699a10,10,0,1,1,20,0V822",
    transform: "translate(-551.967 -615)",
    fill: "rgba(222,184,81,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-19",
    d: "M1278,822V728a10,10,0,0,1,20,0v94",
    transform: "translate(-557.968 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-20",
    d: "M1325,822V738a10,10,0,1,1,20,0v84",
    transform: "translate(-564.946 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-21",
    d: "M1371,822V706a10,10,0,1,1,20,0V822",
    transform: "translate(-570.947 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-22",
    d: "M1417,822V664a10,10,0,1,1,20,0V822",
    transform: "translate(-576.948 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-23",
    d: "M1463,822V630a10,10,0,1,1,20,0V822",
    transform: "translate(-582.948 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-24",
    d: "M1509,822V625a10,10,0,0,1,20,0V822",
    transform: "translate(-588.949 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-25",
    d: "M1555,822V643a10,10,0,0,1,20,0V822",
    transform: "translate(-594.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-26",
    d: "M1601,822V668a10,10,0,1,1,20,0V822",
    transform: "translate(-600.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-27",
    d: "M1648,822V698a10,10,0,1,1,20,0V822",
    transform: "translate(-607.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-28",
    d: "M1694,822V700a10,10,0,0,1,20,0V822",
    transform: "translate(-613.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-29",
    d: "M1740,822V679a10,10,0,0,1,20,0V822",
    transform: "translate(-619.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-30",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-625.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-31",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-585.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-01",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-545.931 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-02",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-505.932 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-03",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-465.932 -615)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "day-40",
    d: "M1786,822V657a10,10,0,1,1,20,0V822",
    transform: "translate(-425.932 -615)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "note-sidebar",
    transform: "translate(-30 141.034)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20",
    "data-name": 20,
    transform: "translate(0 120.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "_40",
    "data-name": 40,
    transform: "translate(0 100.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    id: "_60",
    "data-name": 60,
    transform: "translate(0 78.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "60")), /*#__PURE__*/React.createElement("text", {
    id: "_80",
    "data-name": 80,
    transform: "translate(0 56.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "80")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(-6 36.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_120",
    "data-name": 120,
    transform: "translate(-6 15.966)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "120")), /*#__PURE__*/React.createElement("text", {
    id: "_140",
    "data-name": 140,
    transform: "translate(-6 -6.034)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "140")), /*#__PURE__*/React.createElement("text", {
    id: "_160",
    "data-name": 160,
    transform: "translate(-6 -27.034)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "160")), /*#__PURE__*/React.createElement("text", {
    id: "_180",
    "data-name": 180,
    transform: "translate(-6 -49.034)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "180")), /*#__PURE__*/React.createElement("text", {
    id: "_200",
    "data-name": 200,
    transform: "translate(-6 -68.034)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "200"))), /*#__PURE__*/React.createElement("g", {
    id: "pillar-hover",
    transform: "translate(688 81.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note",
    transform: "translate(-49 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 106,
    height: 50,
    rx: 3,
    transform: "translate(5 8.03)",
    fill: "rgba(222,184,81,0.5)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2021-02-07",
    "data-name": "2021-02-07",
    transform: "translate(21 30.03)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-02-07")), /*#__PURE__*/React.createElement("text", {
    id: "Total_128_Blogs",
    "data-name": "Total 128 Blogs",
    transform: "translate(21 44.03)",
    fill: "#373737",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total 128 Blogs")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.c83181277c233f0c9b9bf6e23a62c1f8.svg";
export { ForwardRef as ReactComponent };